export const formatMoney = (amount: number) => amount.toLocaleString('en-US');
